/**
 * Factory for creating WHIP client instances
 * This allows for dependency injection in tests
 */

import { WhipClient, type WhipClientConfig } from './whipClient';

export type WhipClientFactory = (config: WhipClientConfig) => WhipClient;

export const defaultWhipClientFactory: WhipClientFactory = (config: WhipClientConfig) => {
  return new WhipClient(config);
};
